import { getURLParameter, getCookie, setCookie } from './common'

const crezuEvent = async data => {
  try {
    console.log('trying to get session:', getCookie('session_id'))
    const updatedData = {
      ...data,
      session_id: getSessionId(),
      domain: window.location.hostname,
      utm_source: getURLParameter('utm_source') || window.sbjs.get.current.src,
      utm_medium: getURLParameter('utm_medium') || window.sbjs.get.current.mdm,
      utm_campaign: getURLParameter('utm_campaign') || window.sbjs.get.current.cmp,
      utm_content: getURLParameter('utm_content') || window.sbjs.get.current.cnt,
      utm_term: getURLParameter('utm_term') || window.sbjs.get.current.trm
    }
    await fetch('https://events.crezu.net/api/event', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updatedData)
    })
  } catch (e) {
    console.error(e)
  }
}

const generateUUIDv4 = () => {
  try {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
  } catch (e) {
    console.log('error on generateUUIDv4', e)
    return ''
  }
}

const getSessionId = () => {
  try {
    const EXPIRATION_DAYS = 1 / 48 // 30 min
    const COOKIE_KEY = 'session_id'
    const sessionIdFromCookies = getCookie(COOKIE_KEY)
    let sessionId = null
    if (sessionIdFromCookies) {
      sessionId = sessionIdFromCookies
    } else {
      sessionId = generateUUIDv4()
    }
    setCookie(COOKIE_KEY, sessionId, EXPIRATION_DAYS)
    return sessionId
  } catch (e) {
    console.error('Error on getSessionId', e)
    return ''
  }
}

export { crezuEvent, generateUUIDv4, getSessionId }



// WEBPACK FOOTER //
// ./src/utils/events.js